<header>
    <img src="../../assets/images/Logo_Pure.svg" alt="logo" class="logo">
</header>
<div id="mapa"></div>
